import React from "react";
import {Modal} from "antd";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {UIInputWidgetClient} from "../../../../../common/ui/input/widget/client/ui.input.widget.client";
import {useNavigate} from "react-router";

interface PDFModalProps {
    onClose: () => void;
}
export const MergedInvoiceCreateModal: React.FC<PDFModalProps> = ({ onClose }) => {
    const t = useTranslate();
    const navigate = useNavigate();

    return (
        <Modal
            visible={true}
            title={t("DOCUMENTS.EXPORT.MERGED_INVOICE.CREATE.TITLE" )}
            cancelText={t("CANCEL")}
            footer={false}
        >
            <UIInputWidgetClient
                onChange={agentCode => navigate("/clients/" + agentCode + "/new-invoice-document")}
                valueAsCode
            />
        </Modal>
    );
}